import React, { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from "../../service/validation/forgotEmail";
import AuthContainer from '../../containers/Auth';
import AuthInputText from '../../components/AuthInput';
import { useNavigate } from 'react-router-dom';
import { ApiService } from '../../service/api.service';
import { AUTH_URL } from '../../common/common';
import { phoneCheck } from '../../common/regex';
import { RecaptchaVerifier, signInWithPhoneNumber } from 'firebase/auth';
import { auth } from '../../service/firebase/firebase';
import toast from 'react-hot-toast';
declare global {
  interface Window {
    recaptchaVerifier: RecaptchaVerifier | null;
  }
}
const ForgotPassword = () => {
  const navigate = useNavigate();
  const apiService = new ApiService();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    watch,
  } = useForm({
    defaultValues: { emailId: '' },
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  const initializeRecaptcha = useCallback(() => {
    try {
      if (!window.recaptchaVerifier) {
        const verifier = new RecaptchaVerifier(auth, "recaptcha-container", {
          size: "normal",
          callback: () => {
            console.log("reCAPTCHA solved");
          },
          "expired-callback": () => {
            if (window.recaptchaVerifier) {
              window.recaptchaVerifier.clear();
              window.recaptchaVerifier = null;
            }
            initializeRecaptcha();
          },
        });
        window.recaptchaVerifier = verifier;
        verifier.render(); // ✅ Ensure it's rendered
      }
    } catch (error) {
      console.error("Error initializing reCAPTCHA:", error);
    }
  }, []);

  useEffect(() => {
    initializeRecaptcha();
  }, [initializeRecaptcha]);


  const onSubmit = async (data: any) => {
    try {
      if (!window.recaptchaVerifier) {
        throw new Error("reCAPTCHA not initialized. Please refresh the page.");
      }

      const response: any = await apiService.postApi(
        `${AUTH_URL}/forgot-password-route`,
        data
      );

      if (phoneCheck.test(data.emailId)) {
        try {
          const confirmationResult = await signInWithPhoneNumber(
            auth,
            `+91${data.emailId}`,
            window.recaptchaVerifier
          );

          if (confirmationResult) {
            localStorage.setItem("motsop-verficationId", confirmationResult.verificationId);
          }
        } catch (firebaseError: any) {
          console.error("Firebase sign-in error:", firebaseError);

          // Try extracting deeper message if available
          let friendlyMessage = "Failed to send OTP. Please try again.";

          if (firebaseError?.message?.includes("auth/too-many-requests")) {
            friendlyMessage = "Too many attempts. Please try again later.";
          }

          // If network error message is available (deep JSON in response), extract that too
          if (firebaseError?.customData?._serverResponse) {
            try {
              const parsed = JSON.parse(firebaseError.customData._serverResponse);
              if (parsed?.error?.message === "TOO_MANY_ATTEMPTS_TRY_LATER") {
                friendlyMessage = "You’ve tried too many times. Try again after some time.";
              }
            } catch (e) {
              // fallback silently
            }
          }

          toast.error(friendlyMessage);

          // Re-init CAPTCHA
          if (window.recaptchaVerifier) {
            window.recaptchaVerifier.clear();
            window.recaptchaVerifier = null;
          }
          initializeRecaptcha();
          return;
        }
      }

      if (response?.status == 200 && response?.body?.entityId) {
        const { entityId } = response.body;
        localStorage.setItem('entity_id', entityId);

        if (phoneCheck.test(data.emailId)) {
          localStorage.setItem("phoneNumber", data.emailId);
          navigate('/mobile-otpverfication');
        } else {
          localStorage.setItem('email', data.emailId);
          navigate('/forgototpverfication', {
            state: { emailId: data.emailId },
          });
        }
      }
    } catch (error: any) {
      const message = error?.message || "Something went wrong. Please try again.";
      toast.error(message);
      console.error('Forgot Password Error:', error);

      if (window.recaptchaVerifier) {
        window.recaptchaVerifier.clear();
        window.recaptchaVerifier = null;
      }
      initializeRecaptcha();
    }
  };



  return (
    <AuthContainer>
      <div className="flex w-full rounded-[21.25px] h-full bg-white font-poppins">
        <div className="w-full h-full">
          <div className="md:mx-[4rem] my-[2rem]">
            <div className="h-[100px] w-[239px] bg-[#D9D9D9] flex items-center justify-center">
              logo
            </div>
            <p className="font-[700] text-[20px] mt-6">Welcome Back 👋</p>
            <p className="font-[400] text-[16px] text-[#313957]">
              Forgot into Smart Fleet Management system
            </p>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-6">
              <AuthInputText
                label="Email or Mobile Number"
                value={watch('emailId', '')}
                errors={errors}
                placeholder="Enter Mobile Number or Email"
                autoComplete="email"
                name="emailId"
                register={register}
              />
              <div className='flex items-center w-full justify-center '>
                <div id="recaptcha-container"></div>
              </div>
              <div className="mx-6">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`mt-4 p-2 w-full h-[50px] text-[16px] bg-[#444FBD] rounded-[20px] text-white ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                >
                  {isSubmitting ? 'Submitting...' : 'Send OTP'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default ForgotPassword;
